import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import Cookies from 'js-cookie';

import { Provider } from 'react-redux';
import store, { persistor } from './redux/store';
import { PersistGate } from 'redux-persist/integration/react';

import Popup from './redux-components/Popup';
import Loading from './redux-components/Loading';
import Layout from './Layout';
import Footer from './components/footer';

import './App.css';
import './css/layout.css';
import './css/common.css';
import './css/media.css';

import "./locales/i18n";
import { useRef } from 'react';
import { initGA, logPageView, setUserProperties } from './analytics';
import CookieConsent from './components/CookieConsent';

// GA 추적을 위한 새로운 컴포넌트
function GATracker() {
  const location = useLocation();
  const { mbData } = useSelector((s) => s.usersReducer);

  useEffect(() => {
    const hasConsent = Cookies.get('ga_consent');
    if (hasConsent === 'true') {
      initGA(mbData?.idx);
    }
  }, [mbData]);

  useEffect(() => {
    const hasConsent = Cookies.get('ga_consent');
    if (hasConsent === 'true') {
      logPageView();
    }
  }, [location]);

  return null;
}

function App() {
  const [showCookieSettings, setShowCookieSettings] = useState(false);

  const handleOpenCookieSettings = () => {
    setShowCookieSettings(true);
  };

  /* 빌드시 주석해제 */
  // console = {};
  // console.log = function(){};
  // console.warn = function(){};
  // console.error = function(){};
  
  return (
    <div className="App">
      <BrowserRouter>
        <Provider store={store}>
          <PersistGate persistor={persistor}>
            <GATracker />
            <Layout onOpenCookieSettings={handleOpenCookieSettings} />
            <Popup />
            <Loading />
            <CookieConsent 
              show={showCookieSettings}
              onClose={() => setShowCookieSettings(false)}
            />
          </PersistGate>
        </Provider>
      </BrowserRouter>
    </div>
  );
}

export default App;
